import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSquareBehindSquare2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 3.75C22 2.7835 21.2165 2 20.25 2H9.75C8.7835 2 8 2.7835 8 3.75V8H3.75C2.7835 8 2 8.7835 2 9.75V20.25C2 21.2165 2.7835 22 3.75 22H14.25C15.2165 22 16 21.2165 16 20.25V16H20.25C21.2165 16 22 15.2165 22 14.25V3.75ZM16 15H20.25C20.6642 15 21 14.6642 21 14.25V3.75C21 3.33579 20.6642 3 20.25 3H9.75C9.33579 3 9 3.33579 9 3.75V8H14.25C15.2165 8 16 8.7835 16 9.75V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare2;
